function Page404() {
  return (
    <div className="flex justify-center h-screen items-center">
      <div>
        <p className="text-5xl">404</p>
        <p>Not found</p>
      </div>
    </div>
  );
}

export default Page404;
